<template>
  <div :class="{ opened : value && animated }" class="hamburgerMenu py-1 px-2" @click="toggle">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>
<script>
export default {
  name: 'hamburger-menu',
  props: {
    value: {
      required: true,
      type: Boolean
    },
    animated: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    }
  }
};
</script>
<style scoped>
.hamburgerMenu {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  border: 1.5px solid rgba(30, 58, 95, 0.25);
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0 1px 6px rgba(30, 58, 95, 0.1);
  transition: box-shadow 0.2s, border-color 0.2s;
}

.hamburgerMenu:active {
  box-shadow: 0 1px 3px rgba(30, 58, 95, 0.12);
}

.bar1, .bar2, .bar3 {
  width: 1.4rem;
  height: 2px;
  background-color: #1e3a5f;
  margin: 0.28rem 0;
  border-radius: 2px;
  transition: 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.opened .bar1 {
  -webkit-transform: rotate(-45deg) translate(-0.35rem, 0.35rem);
  transform: rotate(-45deg) translate(-0.35rem, 0.35rem);
}

.opened .bar2 {
  opacity: 0;
  transform: scaleX(0);
}

.opened .bar3 {
  -webkit-transform: rotate(45deg) translate(-0.35rem, -0.35rem);
  transform: rotate(45deg) translate(-0.35rem, -0.35rem);
}
</style>